import React, { ReactElement } from 'react';
import styled from 'styled-components';

const StyledNavItem = styled.span`
  margin: 0 1em 0.25em 1em;
  font-weight: bold;
  cursor: pointer;
  color: black;
  align-items: center;
  display: flex;
  flex-direction: column;

  &:before {
    background-color: purple;
    height: 2px;
    width: 0%;
    transition: all 0.25s ease-in-out;
    margin-bottom: 0.25em;
    content: '';
  }

  &:hover:before {
    width: 100%;
  }

  @media (max-width: 1025px) {
    margin: 0.15em 1.2vw;
    font-size: 1rem;
  }
`;

interface Props {
  children: ReactElement | string;
  onClick?: () => void;
}

const NavItem = (props: Props): ReactElement => {
  const { children, onClick } = props;
  return <StyledNavItem onClick={onClick}>{children}</StyledNavItem>;
};

export default NavItem;
